import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Flex,
  Icon,
  Text,
  useToast,
} from '@chakra-ui/react'

import React from 'react'
import { FiTruck } from 'react-icons/fi'
import { FiAlertTriangle } from 'react-icons/fi'
import { Button } from '../../../../../../components/Button'
import { CalcularTodosFretes } from './CalcularTodosFretes'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { api } from '../../../../../../services/api'

export function UnificarFrete() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [onConfirmAllFretes, setOnConfirmAllFretes] = React.useState(false)
  const { itensPermitidos, infoProposta } = useOrcamentoPedido()
  const cancelRef = React.useRef()

  function handleConfirmAllFretes() {
    setOnConfirmAllFretes(true)

    onClose()
  }

  return (
    <>
      <Button
        onClick={onOpen}
        border={0}
        borderRadius={0}
        bgColor="transparent"
        p={0}
        _hover={{ bgColor: 'transparent' }}
        fontWeight="normal"
        isDisabled={itensPermitidos.length === 0}
        color="#2D2D2D"
        pointerEvents="auto"
      >
        <Flex
          alignItems="center"
          gap={2}
          transition="all 0.2s"
          _hover={{
            bg: '#e2e2e2',
          }}
          px={3}
          py={2}
          cursor="pointer"
        >
          <Icon as={FiTruck} fontSize="20px" color="#378BBF" />
          Unificar Frete
        </Flex>
      </Button>

      <CalcularTodosFretes isOpen={onConfirmAllFretes} onClose={() => setOnConfirmAllFretes(false)} />

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} size="lg">
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              <Flex flexDir="column" gap={4} alignItems="center" justifyContent="center">
                <FiAlertTriangle fontSize="40px" color="#378BBF" />
                <Text textTransform="uppercase" color="white" bg="#378BBF" fontWeight="normal" fontSize="15px" py={1} textAlign="center" w="full">
                  Atenção. Você está prestes a unificar os fretes.
                </Text>
              </Flex>
            </AlertDialogHeader>

            <AlertDialogBody textAlign="center" fontSize="15px" maxW="370px" mx="auto">
              <Text mb="35px">Esta ação irá combinar todos os fretes individuais selecionados em um único frete consolidado.</Text>

              <Text mb="35px">
                Ao prosseguir, <strong>os fretes individuais serão automaticamente descartados</strong>
              </Text>
            </AlertDialogBody>

            <AlertDialogFooter display="flex" justifyContent="center" alignItems="center" gap={3}>
              <Button ref={cancelRef} onClick={onClose} maxW="181px" w="full" bgColor="white" border="1px solid #378BBF" color="#378BBF">
                Voltar
              </Button>
              <Button colorScheme="red" onClick={handleConfirmAllFretes} ml={3} maxW="181px" w="full">
                Confirmar e salvar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
